import { Box } from "@mui/material";
import { Player } from "@lottiefiles/react-lottie-player";
import loadingLogo from "../../theme/logo/logo_loading.json";

const Loading = () => {
  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(245, 245, 245, 0.9)",
        zIndex: 1500,
        backdropFilter: "blur(4px)",
      }}
      role='alert'
      aria-live='assertive'
      aria-label='Loading content'
    >
      <Player
        autoplay
        loop
        src={loadingLogo}
        style={{
          height: "500px",
          width: "500px",
          marginBottom: "0.5rem",
        }}
        aria-label='Animated loading logo'
      />
    </Box>
  );
};

export default Loading;
